import './category.scss';

import categories from '../../assets/js/categories';
import colors from '../../assets/js/colors';

const allTag = {
  name: 'Todos',
  code: 'all',
  designs: []
}


var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var distance = $('#selected-fabric').offset().top,
    $window = $(window);

$window.scroll(function() {
  if ( $window.scrollTop() >= distance ) {
    $('#selected-fabric').addClass('sticky-card');
  } else {
    $('#selected-fabric').removeClass('sticky-card');
  }
});

$(document).ready(function() {


  let parent = document.querySelector('.selected-fabric').parentElement;

  while (parent) {
    const hasOverflow = getComputedStyle(parent).overflow;
    if(hasOverflow !== 'visible') {
      console.log(hasOverflow, parent);
    }
    parent = parent.parentElement;
  }

  categories.forEach(category => {
    allTag.designs = [...allTag.designs, ...category.designs];
  });
  categories.unshift(allTag);

  categories.forEach(category => {
    addCategory(category)
  });

  var categoryCode = getUrlParameter('code');

  if (categoryCode) {
    const filter = categories.find(el => el.code === categoryCode);
    if (filter) {
      allTag.selected = false;
      $('#categories-header').text(filter.name);
      $('#tag-' + categoryCode).addClass('selected');
      addDesigns(filter);
    } else {
      $('#tag-all').addClass('selected');
      addDesigns(allTag);
    }
  } else {
    addDesigns(allTag);
    $('#tag-all').addClass('selected');
  }



  $('.category-tag').on('click', function () {
    const category = categories.find(el => el.code === $(this)[0].id.replace('tag-', ''));
    $($('#selection-row').find('.category-tag')).removeClass('selected');
    $(this).addClass('selected');
    $('#categories-header').text(category.name);
    addDesigns(
        category
    );

    $('html').animate({
      scrollTop: $("#selected-box").offset().top - 100
    }, 350);
  });

});

$(document.body).on('click', '.fabric-box', function(){
  const design = allTag.designs.find(el => el["DISEÑOS"] === $(this)[0].id.replace('box-', ''));
  // $($('#selection-row').find('.category-tag')).removeClass('selected');
  // $(this).addClass('selected');
  changeSelected(design);

  if ($(window).width() < 568) {
    $('html').animate({
      scrollTop: $("#selected-box").offset().top - 100
    }, 350);
  }
})


const addCategory = function (category) {
  $('#selection-row').append(
      `
        <div id="tag-` + category.code + `" class="category-tag` + (category.selected ? ` selected` : ``) + `">
          ` + category.name + `
        </div>
      `
  )
}

const changeSelected = function (design) {
  const colorObj = colors.find(el => el.CVO === design.CVO);
  const colorArr = colorObj.Color.split(' ');

  $('#selected-fabric').empty();
  $('#selected-fabric').append(
      `
      <span class="title allerta">` + design["DISEÑOS"] + `</span>
        <div class="selected-card">
          <div class="fabric-row">
            <div class="img-box">
              <img id="zoom-img" src="../assets/telas/` + getImage(design) + `">
            </div>
            <div class="color-column">
               ${
                  colorArr.map(color => {
                    return '<div class="color-box" style="background: ' + color + '"></div>';
                  }).join('')
              }
            </div>
          </div>
        </div>
      `
  );

  $("#zoom-img").blowup({
    background : "white",
    round: false
  });
}

const addDesigns = function (category) {
  $('.fabrics-column').each(function () {
    const column = $(this);
    column.empty();
    category.designs.forEach(design => {
      column.append(
          `
        <div class="fabric-box" id="box-` + design["DISEÑOS"] + `">
                <div class="img-box">
                  <img src="../assets/telas/` + getImage(design) + `">
                </div>
                <span class="title allerta">` + design["DISEÑOS"] + `</span>
                <span class="subtitle tag bold" style="color: rgb(59,59,59)">Composición</span>
                <span class="subtitle acumin">` + design["COMPOSICION"] + `</span>
                
                <span class="subtitle tag bold" style="color: rgb(59,59,59)">Ancho</span>
                <span class="subtitle acumin">` + design["ANCHO"] + `</span>
                
                <span class="subtitle tag bold" style="color: rgb(59,59,59)">PxML</span>
                <span class="subtitle acumin">` + design["GRS"].ML + `</span>
                
                <span class="subtitle tag bold" style="color: rgb(59,59,59)">PxM2</span>
                <span class="subtitle acumin">` + design["GRS"].M2 + `</span>
                
                 <span class="subtitle tag bold" style="color: rgb(59,59,59)">Rendimiento</span>
                <span class="subtitle acumin">` + design["RENDIMIENTO"] + `</span>
              </div>
        `
      )
    });
    changeSelected(category.designs[0]);
  });
}

const getImage = function (design) {
  return design.imageFolder + '/' + design.imageTag + '_' + design["DISEÑOS"].replaceAll(" ", "_").toLowerCase() + ".png";
}
